<script>
import SidePanel from './side-panel/side-panel.vue';
import { EventBus } from '@utils/event-bus';
import { h } from 'vue';

export default {
    name: 'SidePanelWrapper',
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        renderContent: {
            type: Function,
            default: () => () => null,
        },
    },
    watch: {
        isOpen (val) {
            if (val === false) {
                EventBus.$emit('sidePanelClosed');
            }
        },
    },
    render () {
        if (this.isOpen) {
            const content = this.renderContent?.() || null;

            if (content) {
                const slots = {
                    header: () => content?.children?.header,
                    body: () => content?.children?.body,
                };

                if (content?.children?.headerActions) {
                    slots.headerActions = () => content.children.headerActions;
                }

                return h('div', { class: 'side-panel-container' }, [
                    h(SidePanel, {}, slots),
                    this.$slots.default?.(),
                ]);
            }
        }

        return null;
    },
};
</script>

<style scoped></style>
